module.exports = __webpack_public_path__ + "static/media/air_bed.1c37590a.png";